import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

export function creditStartDateFormatValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const creditStartDate = control.value;
    if (!creditStartDate) {
      return null;
    }

    // Only allow 0 or positive whole numbers like 20, 105 etc.
    // Although the field is named "date", it is not a date field.
    // Instead, it is a number field that represents the offset number of days from the trade date.
    const creditStartDateRegex = /^[0-9]\d*$/;
    if (!creditStartDateRegex.test(creditStartDate)) {
      return {
        incorrect: true,
        message: 'Credit period start date must be a positive whole number',
      };
    }

    return null;
  };
}
